import React from 'react';
import { message } from '@/components';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';
import { elkLog } from '@/utils/elkReport';

export interface CodeEditorStateChangeResp {
  codeEditorEnabled: number;
  codeEditorEnabledUid: string;
  codeEditorDisabledUid: string;
}

export default function useCodeEditorStateChange() {
  const { meeting } = useLocalStore(() => {
    return {
      meeting: meetingModel,
    };
  });
  const { formatMessage } = useIntl();

  const change = async (body: CodeEditorStateChangeResp) => {
    const { codeEditorEnabled, codeEditorEnabledUid, codeEditorDisabledUid } = body;
    elkLog('收到代码编辑器状态变化的通知', { body, codeEditorEnabled });
    if (codeEditorEnabled === 1) {
      message.info({
        content: (
          <span className="text">
            <span>{meeting?.codeEditorUserInfo?.memberName}</span>
            <span>{formatMessage({ id: 'OPEN_EDITOR' })}</span>
          </span>
        ),
        duration: 2,
        noIcon: true,
      });
      meeting.setCodeEditorEnableUid(codeEditorEnabledUid);
      meeting.setCodeEditorEnabled(true);
      meeting.setCodeEditorLoading(true);
    } else {
      meeting.setCodeEditorEnableUid('');
      meeting.setCodeEditorEnabled(false);
      message.info({
        content: (
          <span className="text">
            <span>{meeting?.getMemberInfoByUid(codeEditorDisabledUid)?.memberName}</span>
            <span>{formatMessage({ id: 'EDITOR_CLOSED' })}</span>
          </span>
        ),
        duration: 2,
        noIcon: true,
      });
    }
  };

  return change;
}
